import EntityLinkButton from '../../../../shared/components/linked-entities/EntityLinkButton';
import React from 'react';
import { AssetIcon } from '../../../../shared/assets';
import {
  formatProposalDate,
} from '@/modules/deals/utils';
import { resolveDealResponsible } from '../../shared/utils/dealStaff';

function getClientResolutionHint(status) {
  if (status === 'legacy_fallback') {
    return 'Cliente da snapshot legacy';
  }

  if (status === 'missing_client_id') {
    return 'ClientId mancante';
  }

  if (status === 'unresolved_client_reference') {
    return 'ClientId non risolto nel catalogo clienti';
  }

  return '';
}

const ProposalCard = ({
  proposal,
  onClick,
  onOpenClient,
  onOpenStaff,
  provided,
  snapshot,
  staff = [],
}) => {
  const clientName = proposal.clientResolvedName || proposal.client || 'Cliente non risolto';
  const clientResolutionHint = getClientResolutionHint(proposal.clientResolutionStatus);
  const canOpenClient = Boolean(proposal.clientId);
  const responsible = resolveDealResponsible(proposal, staff);

  return (
    <article
      ref={provided.innerRef}
      {...provided.draggableProps}
      className={snapshot.isDragging ? 'deals-card is-dragging' : 'deals-card'}
      onClick={() => onClick(proposal)}
    >
      <div className="deals-card__inner">
        <div className="deals-card__header">
          <div
            {...provided.dragHandleProps}
            className="deals-card__handle"
            aria-label="Sposta proposta"
          >
            <AssetIcon name="actions.menu" size={16} />
          </div>

          <h4 className="deals-card__title">
            {proposal.name}
          </h4>

          <span className={`deals-badge deals-badge--${proposal.priority}`}>
            {proposal.priority}
          </span>
        </div>

        <div className="deals-card__content">
          <EntityLinkButton
            className="deals-card__section"
            disabled={!canOpenClient}
            aria-label={`Apri cliente ${clientName}`}
            onClick={(e) => {
              if (!canOpenClient) return;
              e.stopPropagation();
              onOpenClient?.(proposal.clientId, clientName);
            }}
          >
            <span className="deals-card__label">
              <AssetIcon name="nav.clients" size={16} />
              Cliente:
            </span>
            <p className={canOpenClient ? 'deals-card__value deals-card__link-text' : 'deals-card__value'}>
              {clientName}
            </p>
            {clientResolutionHint ? (
              <p className="deals-card__hint">{clientResolutionHint}</p>
            ) : null}
          </EntityLinkButton>

          <div>
            <span className="deals-card__label">Valore:</span>
            <p className="deals-card__value deals-card__money">
              {proposal.estimatedValue || proposal.value || '—'}
            </p>
          </div>

          <div>
            <span className="deals-card__label">
              <AssetIcon name="nav.team" size={16} />
              Responsabile:
            </span>
            {responsible.hasLinkedStaff ? (
              <EntityLinkButton
                type="button"
                className="deals-card__person-link"
                aria-label={`Apri scheda staff di ${responsible.label}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onOpenStaff?.(responsible.staffId, responsible.staffMember);
                }}
                onKeyDown={(event) => {
                  if (event.key !== 'Enter' && event.key !== ' ') return;
                  event.preventDefault();
                  event.stopPropagation();
                  onOpenStaff?.(responsible.staffId, responsible.staffMember);
                }}
              >
                {responsible.label}
              </EntityLinkButton>
            ) : (
              <p className="deals-card__value">
                {responsible.label}
              </p>
            )}
            {responsible.hasLegacyAssignee ? (
              <p className="deals-card__hint">
                Label legacy: collegamento staff non disponibile
              </p>
            ) : null}
            {responsible.hasMissingStaffReference ? (
              <p className="deals-card__hint">
                Dati staff non disponibili
              </p>
            ) : null}
          </div>

          <div>
            <span className="deals-card__label">Data proposta:</span>
            <p className="deals-card__value">
              {formatProposalDate(proposal.proposalDate)}
            </p>
          </div>
        </div>
      </div>
    </article>
  );
};

export default ProposalCard;
